import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { BootstrapThemeProp, BootstrapThemeService, BootstrapThemeType } from '@app/core/services/bootstrap-theme.service';
import { ContainerService } from '@app/core/services/container.service';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

@Component({
    selector: 'modal-hoc',
    templateUrl: './modal-hoc.component.html',
    styleUrl: './modal-hoc.component.scss',
    standalone: false
})
export class ModalHocComponent implements OnInit {
    @Input() public modalTheme: BootstrapThemeProp = 'primary';
    themeType: BootstrapThemeType;
    @Input() public icon?: IconDefinition;
    @Input() public modalTitle: string = 'Modal Title';

    @Input() public submitButton: boolean = true;
    @Input() public secondaryButton: boolean = false;
    @Input() public cancelButton: boolean = true;

    @Input() public submitText: string = 'Submit';
    @Input() public secondaryText: string = 'Share / Copy';
    @Input() public cancelText: string = 'Cancel';

    @Input() public secondaryButtonClasses: string[] = ['modal-secondary', 'me-auto', 'btn-link']

    @Input() public submitDisabled: boolean = false;
    @Input() public secondaryDisabled: boolean = false;
    @Input() public cancelDisabled: boolean = false;
    @Input() public closeDisabled: boolean = false;

    @Input() public isBeta: boolean = false;

    container: HTMLElement;

    @Output() public readonly modalSubmit: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
    @Output() public readonly modalSecondary: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

    /**
     * The modal has been canceled by clicking either the X button in the header or the cancel button in the footer
     */
    @Output() public readonly modalCancel: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
    /**
     * The modal has been canceled by clicking the X button in the header
     */
    @Output() public readonly modalCancelByX: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
    /**
     * The modal has been canceled by clicking the cancel button in the footer
     */
    @Output() public readonly modalCancelByButton: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
    /**
     * The modal backdrop has been clicked (if enabled)
     */
    @Output() public readonly modalBackdropClick: EventEmitter<void> = new EventEmitter<void>();

    @HostListener('window:click', ['$event'])
    windowClicked($event: PointerEvent): void {
        const backdrop: EventTarget = this.container.querySelector('ngb-modal-backdrop');

        // If the backdrop was one of the elements that was clicked (should only be one anyway), emit the event
        if (backdrop && $event.composedPath().some((element) => element === backdrop)) {
            this.modalBackdropClick.emit();
        }
    }

    constructor(
        private readonly containerService: ContainerService,
        private readonly bootstrapThemeService: BootstrapThemeService
    ) {}

    ngOnInit(): void {
        this.container = this.containerService.getContainer();
        this.themeType = this.bootstrapThemeService.getThemeType(this.modalTheme);
    }

    public get modalHeaderClasses(): string {
        return `fdx-header-bg-${this.modalTheme}`;
    }

    public get hasFooter(): boolean {
        return this.submitButton || this.secondaryButton || this.cancelButton;
    }

    public get submitButtonClass(): string {
        return `btn-${this.modalTheme}`;
    }

    public onModalSubmit(e: MouseEvent): void {
        this.modalSubmit.emit(e);
    }

    public onModalSecondary(e: MouseEvent): void {
        this.modalSecondary.emit(e);
    }

    public onModalXClick(e: MouseEvent): void {
        this.modalCancelByX.emit(e);
        this.modalCancel.emit(e);
    }

    public onModalCancel(e: MouseEvent): void {
        this.modalCancelByButton.emit(e);
        this.modalCancel.emit(e);
    }
}
